
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

/* 
  The original file used a TypeScript type annotation (`React.FC`) but the
  project is being compiled as plain JavaScript/JSX, which caused the parser
  to treat the colon (`:`) as invalid JSX syntax.  
  Removing the type annotation (or converting the file to `.tsx`) resolves the
  syntax errors while keeping the component’s behaviour unchanged.
*/
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Hide the navbar when scrolling past the hero section
      const heroHeight = window.innerHeight;
      setIsVisible(window.scrollY < heroHeight - 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/20 backdrop-blur-sm ${
          isVisible
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 -translate-y-full pointer-events-none'
        }`}
      >
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center cursor-pointer">
              <img
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/80ff5c93b4a3019548b68e429c50a7d0.png"
                alt="Logo"
                className="h-16 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              <Link
                to="/"
                className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-white/80"
              >
                الرئيسية
              </Link>
              <Link
                to="/about"
                className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-white/80"
              >
                عن مدار
              </Link>
              <Link
                to="/company-profile"
                className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-white/80"
              >
                منظومه مدار
              </Link>
              <Link
                to="/projects"
                className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-white/80"
              >
                مشاريعنا
              </Link>
              <Link
                to="/partners"
                className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-white/80"
              >
                عملاؤنا
              </Link>
              <Link
                to="/contact"
                className="px-6 py-2.5 rounded-lg transition-colors cursor-pointer text-sm font-medium whitespace-nowrap bg-white text-dark hover:bg-white/90"
              >
                تواصل معنا
              </Link>
            </div>

            {/* Mobile menu button */}
            <div className="lg:hidden flex items-center">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="focus:outline-none text-white hover:text-white/80"
              >
                <i className={`ri-${isOpen ? 'close' : 'menu'}-line text-2xl`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <Link
                to="/"
                className="block px-3 py-2 text-base font-medium text-primary hover:bg-gray-100 rounded-lg"
              >
                الرئيسية
              </Link>
              <Link
                to="/about"
                className="block px-3 py-2 text-base font-medium text-primary hover:bg-gray-100 rounded-lg"
              >
                عن مدار
              </Link>
              <Link
                to="/company-profile"
                className="block px-3 py-2 text-base font-medium text-primary hover:bg-gray-100 rounded-lg"
              >
                منظومه مدار
              </Link>
              <Link
                to="/projects"
                className="block px-3 py-2 text-base font-medium text-primary hover:bg-gray-100 rounded-lg"
              >
                المشاريع
              </Link>
              <Link
                to="/partners"
                className="block px-3 py-2 text-base font-medium text-primary hover:bg-gray-100 rounded-lg"
              >
                عملاؤنا
              </Link>
              <Link
                to="/contact"
                className="block px-3 py-2 text-base font-medium text-primary hover:bg-gray-100 rounded-lg"
              >
                اتصل بنا
              </Link>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
